module.exports = __webpack_public_path__ + "img/xianweijing.f1768228.jpg";